import React from 'react'
import { useField } from 'formik'

import includes from 'lodash/fp/includes'
import './style.css'

type CheckboxFieldProps = {
  label: any
  value: string
  className?: string
  onChange?: (value?: boolean) => void
  name: string
  disabled?: boolean
  ariaLabel?: string
  customization?: any
}

const CustomCheckboxField = ({
  label,
  value,
  onChange,
  disabled,
  name,
  ariaLabel,
}: CheckboxFieldProps) => {
  const [field, , { setValue }] = useField(name)
  const isChecked = includes(value, field.value)

  const checked = field && typeof field.value === 'object' ? isChecked : field.value

  const handleChange = (event: any) => {
    field.onChange(event)
    if (onChange) onChange(event.target.checked)
  }

  const onKeyDown = (event: any) => {
    if (event.keyCode !== 13) return
    const newValue = checked
      ? field.value.filter((curr: string) => curr !== value)
      : field.value.concat([value])

    setValue(newValue)
    if (onChange) onChange(!checked)
  }

  return (
    <div className="container">
      <div className="checkbox_btn action">
        <label>
          <input
            {...field}
            disabled={disabled}
            type="checkbox"
            value={value}
            onChange={handleChange}
            onClick={(e) => {
              e.stopPropagation()
            }}
            aria-checked={checked}
            onKeyDown={onKeyDown}
            checked={checked}
            aria-label={ariaLabel ? ariaLabel : label}
            id={`${name}_${value}`}
          />
          <span>{label}</span>
        </label>
      </div>
    </div>
  )
}

export default CustomCheckboxField
